import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Raven from 'raven-js';

// Import the same App component the server will
import { App } from 'containers';

// Configure Sentry to log uncaught exceptions
Raven.config(process.env.REACT_APP_SENTRY_DSN, {
  whitelistUrls: [ /imageresize\.org/ ] // ignore errors caused by ads and other third-party scripts
}).install();

// On the server we populate an object on the window. If it exists, we use that object to prepopulate
// the state as well as render with the new `hydrate` method.
const isSSR = !!window.IMAGERESIZE_APP_PROPS;
const ROOT = document.getElementById('root');

if (isSSR) {
  ReactDOM.hydrate(
    <BrowserRouter>
      <App { ...window.IMAGERESIZE_APP_PROPS } />
    </BrowserRouter>,
    ROOT
  );
} else {
  ReactDOM.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    ROOT
  );
}



// WEBPACK FOOTER //
// ./src/index.jsx